import { gql } from '@apollo/client';

export const CREATE_CERTIFICATE_TEMPLATE_OVERRIDE = gql`
    mutation CertificateTemplateOverride($input: CreateCertificateTemplateOverrideInput!) {
        result: createCertificateTemplateOverride(input: $input) { 
            id
            name
            description
            certificateTemplateId
            templateKey
            segments
            weight
            certificateTemplateOverrideUrl
            createdAt
            updatedAt
        }
    }
`;

